import { render, staticRenderFns } from "./SentInPeriod.vue?vue&type=template&id=70bcb7be&"
import script from "./SentInPeriod.vue?vue&type=script&lang=js&"
export * from "./SentInPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports